module.exports = __webpack_public_path__ + "img/Nicaragua.e3146a82.png";